import React from 'react';
import { Link } from "gatsby"

import AboutImg from "../../assets/images/about-img2.png"
import Shape15 from "../../assets/images/shape/shape15.png"

const AboutServicesSection = () => {
    return (
        <div className="about-area pb-100">
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-12">
                        <div className="about-img">
                            <img src={AboutImg} alt="AI-Powered Transformation" />
                        </div>
                    </div>

                    <div className="col-lg-4 col-sm-6 col-md-6">
                        <div className="about-content">
                            <div className="text">
                                <span className="sub-title">From Idea to Implementation</span>
                                <h2>Your one-stop shop for <br></br>AI Solutions</h2>
                                <h2></h2>
                                {/* <p> At cimplify.ai, we help our clients achieve incredible new possibilities with AI.</p> */}
                                
                                <ul className="funfacts-list">
                                
                                    <li>
                                    <Link to="/vision-artifical-intelligence-services">
                                        <div className="list">
                                            {/* <i className="flaticon-menu-1"></i> */}
                                            <h6 style={{ color: '#0D5923' }}>Vision AI</h6>
                                            <p>For Computer Vision</p>
                                        </div>
                                    </Link>    
                                        
                                    </li>
                                    
                                    <li>
                                    <Link to="/ai-in-conversations">
                                        <div className="list">
                                            {/* <i className="flaticon-web-settings"></i> */}
                                            <h6 style={{ color: '#0D5923' }}>Conversational AI</h6>
                                            <p>For Chatbots & Assistants</p>
                                        </div>
                                    </Link> 
                                    </li>
                                    
                                
                                
                               
                                    <li>
                                
                                    <Link to="/natural-language-nlp-services">
                                        <div className="list">
                                        
                                            {/* <i className="flaticon-conversation"></i> */}
                                            <h6 style={{ color: '#0D5923' }}>NLP </h6>
                                            <p>For Text & Voice Analysis</p>
                                        </div>
                                    </Link> 
                                    </li>
                                    <li>
                                    <Link to="/predictive-artificial-intelligence-services">
                                        <div className="list">
                                            {/* <i className="flaticon-conversation"></i> */}
                                            <h6 style={{ color: '#0D5923' }}>Predictive AI</h6>
                                            <p>For Decision Making</p>
                                        </div> 
                                    </Link> 
                                    </li>
                                
                                </ul>

                                <Link to="/featured-services" className="default-btn">
                                    Explore Services
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="shape15">
                <img src={Shape15} alt="Shape" />
            </div>
        </div>
    )
}

export default AboutServicesSection;